"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var constants_1 = require("../constants");
function getRouteFromPathname(pathname) {
    return pathname
        .split(constants_1.ROUTE_DIVIDER)
        .slice(0, 3)
        .join(constants_1.ROUTE_DIVIDER);
}
exports.default = getRouteFromPathname;
//# sourceMappingURL=getRouteFromPathname.js.map